define('plugin/line-liff/controller/LineLiffController',['require','lib/controller/BaseController','plugin/line-liff/view/LineLiffClientLoginStepView','lib/view/ModalRegion'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var LineLiffClientLoginStepView = require('plugin/line-liff/view/LineLiffClientLoginStepView');
    var ModalRegion = require('lib/view/ModalRegion');

    /**
     * Line liff Controller
     *
     * @class LineLiffController
     */
    return BaseController.extend({

        _clientModel: null,
        _handler: null,
        _backUrl: null,

        initialize: function () {
            this._clientModel = this.getOption('clientModel');

            this._handler = this.getOption('handler');

            BaseController.prototype.initialize.call(this);
        },

        signIn: function (back, message) {
            this._signIn(this.getMainLayout().getContentRegion(), back, message);
        },

        lineContext: function(context){
            //console.log('line context redirect', context);
            var onCallback = function () {
                setTimeout(function(){
                    Backbone.Wreqr.radio.vent.trigger('loader', 'hide');
                }, 1000);

                Backbone.history.navigate('book', {
                    trigger: true,
                    //replace: true
                });
            };

            var timeout = setTimeout(function(){
                onCallback();
            }, 7000);

            this._handler.onLiffApiReady(function (){
                clearTimeout(timeout);
                onCallback();
            });
            Backbone.Wreqr.radio.vent.trigger('loader', 'show');
        },

        _signIn: function (region, back, message) {
            this._backUrl = back;

            var view = new LineLiffClientLoginStepView({
                clientModel: this._clientModel,
                termsModel: this._handler.getTermsController().getModel(),
                message: message,
                onlySignIn: false,
            });

            this.listenTo(view, 'signIn', _.bind(function (data) {
                this._handler.performSignIn(data.view.getDataToSignIn());
            }, this));
            //
            this.listenTo(view, 'skipStep', _.bind(function (data) {
                this._handler.skipStepPage();
            }, this));

            this.listenTo(view, 'dom:refresh', _.bind(function () {
                view.showTermsAndConditions(this._handler.getTermsController().getView());
            }, this));

            this.listenTo(view, 'clientLogged', this.performRedirectBack);

            region.show(view);
        },

        performRedirectBack: function () {
            if (!this._backUrl) {
                this._backUrl = 'client/profile';
            }
            this._redirect(this._backUrl);
        }

    });

});
